<div class="loader-container" *ngIf="!dataLoaded && firstLoad">
  <div class="loader">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" />
    </svg>
  </div>
</div>

<div class="fadeInUp" *ngIf="!firstLoad">

  <app-language-selector></app-language-selector>

  <button  *ngIf="bookingType === 'new'" id="flight-results-back" type="button"
    class="btn btn-link hidden-sm hidden-xs back-btn" (click)="redirectToSearch()">
    <i class="icon">chevron_left</i>{{ appCopy.panelHeader['linkBack'+selectedLanguage] }}
  </button>

  <button type="button" class="btn btn-link back-btn" *ngIf="bookingType === 'amend'" (click)="cancelAmend()">
    <i class="icon">chevron_left</i>{{ appCopy.panelHeader['linkCancel'+selectedLanguage] }}
  </button>

  <h1 class="text-dark-blue h1">{{ appCopy.panelHeader['title'+selectedLanguage] }}</h1>
  <p class="text-dark-blue">{{ appCopy.panelHeader['content'+selectedLanguage] }}</p>

  <div class="panel panel--shadow panel--full-width margin-top-16">
    <div class="panel-body">
      <div class="flex-always flex--space-between">
        <div *ngIf="flightData.airlineName !== null">
          <div *ngIf="flightData.isPartner">
            <img class="airline-logo-full" [src]="'./images/airline-logo-full/' + flightData.airlineName + '.svg'"
              [alt]="flightData.airlineName + ' logo'" />
          </div>
          <div *ngIf="!flightData.isPartner">
            <p>{{ flightData.airlineName }}</p>
          </div>
        </div>
        <div>
          <p>{{ flightData.date | date:'E, d MMM yyyy' :'' : languageCode }}</p>
        </div>
      </div>
    </div>
    <div class="panel-body">
      <div class="flex-always flex--space-between">
        <div class="flight-results-summary flex-lg flex-md">
          <div class="flex-lg flex-md flex-sm">
            <span>{{ appAirportCopy[flightData.originAirportCode]['airportDisplayText'+selectedLanguage]}}</span>
            <!-- <i class="icon hidden-lg hidden-md">arrow_right</i> -->
            <i class="icon hidden-xs">plane_solid</i>
          </div>
          <p class="hidden-lg hidden-md hidden-sm summary-mobile-separator">To</p>
          <span>{{ appAirportCopy[flightData.destinationAirportCode]['airportDisplayText'+selectedLanguage]}}</span>
        </div>
        <div *ngIf="bookingType === 'new'" class="flex-divider margin-left-16 margin-right-16"></div>
        <a *ngIf="bookingType === 'new'" id="changeFlightLink" class="btn btn-xs btn-link" href="javascript:void(0);" (click)="toggleSearchModal()">
          {{ appCopy.panelHeader['buttonEdit'+selectedLanguage] }}<i class="icon margin-left-8">edit</i>
        </a>
      </div>
    </div>
  </div>

  <form class="flight-results-filter row margin-bottom-24" novalidate>

    <div class="col-md-5">
      <div id="flightSearchForm" class="form-group form-group-sm with-icon">
        <input class="form-control form-control--rounded" id="flightNumberInput" name="flightNumberInput"
          ngControl="flightNumberInput" type="text" autocomplete="nope" [(ngModel)]="flightSearchString" #flightNumberInput="ngModel"
          (keydown.enter)="searchByFlightNumber(flightNumberInput.value)" appCheckEmpty>
        <label class="control-label" for="flightNumberInput">{{
          appCopy.panelHeader['inputSearchFlightNumberLabel'+selectedLanguage] }}</label>
          <button *ngIf="!initialFlightSearchString" class="form-button" type="button" (click)="searchByFlightNumber(flightNumberInput.value)">
            <i class="icon">search</i>
          </button>
          <button *ngIf="initialFlightSearchString" class="form-button" type="button" (click)="clearFlightSearch()">
            <i class="icon">cross</i>
          </button>
      </div>
    </div>

    <div class="col-md-7">
      <!-- *ngIf="direction !== 2" -->
      <div class="radio-toggle radio-toggle--3" style="background-color: #DBE5FD;" >
        <div class="active-item-bg" [style.transform]="'translateX(' + activeRadioIndex * 100 + '%)'"></div>
        <div class="flex-always">
          <div class="radio radio-toggle__item">
            <input type="radio" name="flightStops" ngControl="flightStops" id="flightDirect" value="0"
              [(ngModel)]="legsFilter" (ngModelChange)="filterLegChanged($event, 'direct')"
              [disabled]="flightSelectionDisabled">
            <label class="flight-stop" for="flightDirect">{{ appCopy.panelHeader['buttonFlightDirect'+selectedLanguage]
              }}</label>
          </div>
          <div class="radio radio-toggle__item">
            <input type="radio" name="flightStops" ngControl="flightStops" id="flightOneStop" value="1"
              [(ngModel)]="legsFilter" (ngModelChange)="filterLegChanged($event, 'oneStop')"
              [disabled]="flightSelectionDisabled">
            <label class="flight-stop" for="flightOneStop">{{
              appCopy.panelHeader['buttonFlightOneStop'+selectedLanguage] }}</label>
          </div>
          <div class="radio radio-toggle__item">
            <input type="radio" name="flightStops" ngControl="flightStops" id="flightTwoStop" value="2"
              [(ngModel)]="legsFilter" (ngModelChange)="filterLegChanged($event, 'twoStop')"
              [disabled]="flightSelectionDisabled">
            <label class="flight-stop" for="flightTwoStop">{{
              appCopy.panelHeader['buttonFlightTwoStop'+selectedLanguage] }}</label>
          </div>
        </div>
      </div>
    </div>
    <!-- <a *ngIf="flightSelectionDisabled" href="javascript:void(0)" (click)="cancelClick($event)">Cancel</a> -->
  </form>

  <div  *ngIf="!dataLoaded">
    <ul class="showloader">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
  </div>
  <div *ngIf="dataLoaded">

    <div *ngIf="flightResults.length === 0 && direction === 1">
      <div class="alert alert-ghost flex-always margin-bottom-8">
        <div class="sprite sprite--alert-checklist margin-right-16"></div>
        <div>
          <h3 *ngIf="!isMultiLegFlight" class="margin-top-0 margin-bottom-0">{{
            appCopy.panelHeader['errorTextIsNotMultiLegFlight'+selectedLanguage] }}</h3>
          <h3 *ngIf="isMultiLegFlight" class="margin-top-0 margin-bottom-0">{{
            appCopy.panelHeader['errorText'+selectedLanguage] }}</h3>
          <p>{{ appCopy.panelHeader['errorTextFlightDirect'+selectedLanguage] }}</p>
          <!-- <a *ngIf="!isMultiLegFlight" href="javascript:void(0)" (click)="callMultiLegApi($event)">Search non-direct flights?</a> -->
        </div>
      </div>
      <a class="link" href="/flight-finder/search">{{ appCopy.panelHeader['linkSearchAgain'+selectedLanguage]
        }}</a>
    </div>

    <div *ngIf="flightResults.length === 0 && direction === 2">
      <div class="alert alert-ghost flex-always margin-bottom-8">
        <div class="sprite sprite--alert-checklist margin-right-16"></div>
        <div>
          <h3 class="margin-top-0 margin-bottom-0">{{ appCopy.panelHeader['errorText'+selectedLanguage] }}</h3>
          <p>{{ appCopy.panelHeader['errorTextFlightOneStop'+selectedLanguage] }}</p>
        </div>
      </div>
      <a class="link" href="/flight-finder/search">{{ appCopy.panelHeader['linkSearchAgain'+selectedLanguage]
        }}</a>
    </div>

    <ul class="list-unstyled flight-results" *ngIf="flightResults.length > 0">
      <li *ngFor="let item of flightResults; let i = index" id="flightResultItem{{i}}" class="reveal"
        [class.is-open]="item.flightInfo.id === selectedFlightId">

        <div class="reveal__toggle flight-item panel panel--shadow" tabindex="0" role="button"
          [attr.aria-expanded]="item.flightInfo.id === selectedFlightId"
          (click)="toggleSelectedItem($event, item.flightInfo)"
          (keyup.enter)="toggleSelectedItem($event, item.flightInfo)"
          (keyup.space)="toggleSelectedItem($event, item.flightInfo); $event.preventDefault()">
          <div class="panel-body flex-always">
            <div
              [ngClass]="'hidden-xs airline-logo airline-logo--' + item.flightStatusDetails[0].airlineCode.replace('*', '')">
            </div>
            <div class="flex-lg flex__item--grow">
              <div class="flex__item--equal">
                <p style="text-transform: none;">{{ item.flightStatusDetails[0].airlineName }}</p>
                <p><span class="hidden-xs">{{ appCopy.panelHeader['titleFlight'+selectedLanguage] }} </span>{{
                  item.flightStatusDetails[0].airlineCodeDisplayName }}{{
                  item.flightStatusDetails[0].flightNumber }}
                  <span id="info" (click)="showLinkedFlights($event, item)">
                    <span  class="icon-information icon-black icon_18"></span>
                  </span>
                </p>
              </div>
              <div class="flex__item--equal" *ngIf="item.flightStatusDetails.length > 1">
                <p class="visible-lg-block">{{ appCopy.panelHeader['titleStops'+selectedLanguage] }}</p>
                <p class="flex-always text-extra-bold">
                  {{ item.flightStatusDetails[0].departureAirport.airportCode }}
                  <ng-container *ngFor="let leg of item.flightStatusDetails">
                    <span class="leg-divider"></span>
                    {{ leg.arrivalAirport.airportCode }}
                  </ng-container>
                </p>
              </div>
            </div>
            <div class="flex-divider margin-right-0 hidden-sm hidden-xs"></div>
            <div class="flex-lg flex-md flight-item__departure">
              <p>{{ appCopy.panelHeader['titleDeparts'+selectedLanguage] }}</p>
              <h4 class="text-extra-bold margin-top-0 margin-bottom-0">{{
                item.flightStatusDetails[0].departureDateTimeDetails.scheduledDateTimeLocal | amDateFormat: 'HH:mm' }}
              </h4>
            </div>
          </div>
        </div>

        <div class="reveal__content show-scroll"
          [appRevealContent]="item.flightInfo.id === selectedFlightId"
          [revealMaxHeight]="revealMaxHeight">
          <app-flight-details *ngIf="item.flightInfo.id === selectedFlightId" [flightData]="item"
            [appAirportCopy]="appAirportCopy" [appCopy]="appCopy"
            [selectedLanguage]="selectedLanguage" [languageCode]="languageCode" (cancelFlight)="handleCancelFlight($event)"
            (confirmFlight)="handleConfirmFlight($event)" [isFlyback]="false">
          </app-flight-details>
        </div>
      </li>
    </ul>

    <!-- <div class="margin-top-24" *ngIf="flightResults.length > 0 && direction === 2">
      <div class="alert alert-ghost flex-always margin-bottom-8">
        <div class="sprite sprite--alert-checklist margin-right-16"></div>
        <div>
          <h3 class="margin-top-0 margin-bottom-0">Flight not found?</h3>
          <p>If you can't see your flight? It might have a stopover.<br> Search again with the departure airport and
            airline for the plane that arrives in the UK.</p>
        </div>
      </div>
      <a class="link" routerLink='/flight-finder/search'>Search again</a>
    </div> -->
    <!-- <button type="button" class="btn btn-ghost btn-primary btn-block">Show more</button> -->
  </div>


  <div style="visibility: hidden; position: absolute">
    <!-- Sojern Tag v3_image, Pixel Version: 1 -->
    <!-- Provide the values for the following keys: -->
    <!-- fa1 - Origin Airport -->
    <!-- fa2 - Destination Airport -->
    <!-- et - DCO -->
    <img alt='Sojern Image Pixel' height='1'
      src='https://pixel.sojern.com/pixel/img/135347?p_v=1&f_v=v3_image&vid=air&et=fs&fa1={{flightData.originAirportCode}}&fa2={{flightData.destinationAirportCode}}&et='
      width='1'>
    <!-- End Sojern Tag -->
  </div>
</div>
